import { symptomFilters } from './mock';

export const sexOptions = [
  { id: 'female', label: 'Female' },
  { id: 'male', label: 'Male' },
  { id: 'other', label: 'Prefer not to say' }
];

export const ageOptions = [
  { id: 'baby', label: 'Baby (0–2)' },
  { id: 'child', label: 'Child (3–12)' },
  { id: 'teen', label: 'Teen (13–17)' },
  { id: 'adult', label: 'Adult (18–64)' },
  { id: 'elder', label: 'Elder (65+)' }
];

export const symptomOptions = symptomFilters;

// Common contraindications, each mapped to keywords found in item safety notes
export const conditionOptions = [
  { id: 'pregnancy', label: 'Pregnancy', keywords: ['pregnan'] },
  { id: 'breastfeeding', label: 'Breastfeeding / Nursing', keywords: ['nursing', 'breastfeed', 'lactation'] },
  { id: 'high_bp', label: 'High blood pressure', keywords: ['blood pressure', 'hypertension'] },
  { id: 'epilepsy', label: 'Epilepsy / Seizures', keywords: ['epilepsy', 'epileptic', 'seizure'] },
  { id: 'asthma', label: 'Asthma', keywords: ['asthma'] },
  { id: 'hayfever', label: 'Hay fever / Ragweed allergy', keywords: ['ragweed', 'hay fever', 'hayfever', 'allergy', 'allergic'] },
  { id: 'blood_thinners', label: 'Blood thinners (anticoagulants)', keywords: ['blood thinner', 'thin blood', 'thins blood', 'anticoagulant'] },
  { id: 'kidney', label: 'Kidney issues', keywords: ['kidney'] },
  { id: 'thyroid', label: 'Thyroid condition', keywords: ['thyroid'] },
  { id: 'diabetes', label: 'Diabetes', keywords: ['blood sugar', 'diabet'] },
  { id: 'gallbladder', label: 'Gallbladder issues / Gallstones', keywords: ['gallstone', 'gallbladder'] },
  { id: 'autoimmune', label: 'Autoimmune condition', keywords: ['autoimmune', 'immunosuppress'] },
  { id: 'sedatives', label: 'Taking sedatives', keywords: ['sedative'] }
];

export function conditionLabel(id) {
  return conditionOptions.find((c) => c.id === id)?.label || id;
}

// Union of a family/individual profile's conditions
export function effectiveConditions(profile, allProfiles = []) {
  if (!profile) return [];
  if (profile.is_family) {
    const set = new Set(profile.conditions || []);
    (profile.member_ids || []).forEach((mid) => {
      const m = allProfiles.find((p) => p.profile_id === mid);
      (m?.conditions || []).forEach((c) => set.add(c));
    });
    return [...set];
  }
  return profile.conditions || [];
}

function conditionKeywords(conditionIds) {
  const kws = [];
  (conditionIds || []).forEach((id) => {
    const c = conditionOptions.find((o) => o.id === id);
    if (c) kws.push(...c.keywords);
  });
  return kws;
}

// A herb/oil is allowed if its safety note does NOT mention any condition keyword
export function isLibraryItemAllowed(item, conditionIds) {
  if (!conditionIds || !conditionIds.length) return true;
  const kws = conditionKeywords(conditionIds);
  const text = (item.safety || '').toLowerCase();
  return !kws.some((k) => text.includes(k));
}

// Recipe filtering by an individual profile's sex & age (family profiles skip sex/age)
export function isRecipeAllowed(recipe, profile) {
  if (!profile || profile.is_family) return true;
  const sex = profile.sex;
  if (sex === 'female' || sex === 'male') {
    if (recipe.gender !== 'all' && recipe.gender !== sex) return false;
  }
  const age = profile.age;
  if (age && age !== 'any' && !recipe.ages.includes(age)) return false;
  return true;
}
